import { createSelector } from 'reselect';
import { paramsReducer } from '../reducers';
import * as scenariosSelector from './scenario';

export const getScenarioParamsByRunnerId = createSelector(
  paramsReducer.paramsByJobIds,
  scenariosSelector.regressionAllScenarios,
  ( paramsByJobIds, regressionAllScenarios ) => {
    const result = regressionAllScenarios.reduce((acc, scenario) => {
      acc[scenario.runner] = paramsByJobIds[scenario.runner];
      return acc;
    }, {});
    return result;
  }
);


// WEBPACK FOOTER //
// src/selectors/params.js